// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__21ZY_","uploadButton":"index_uploadButton__2t7uC","uploadButton_tip":"index_uploadButton_tip__22X-f","tip":"index_tip__W0BPS"};